import { gql } from 'graphql-request';

export const LAPSER_AND_ADVRENEWAL_DATA_QUERY = gql`
  query ($country: String!) {
    lapserAdvanceRenewalNudge(country: $country) {
      status
      message
      lapserAdvanceRenewal {
        nudgeType
        tier
        diffDays
        repeatValue
        actionData {
          id
          planId
          planName
          planDuration
          planPrice
          targetPage
        }
        advanceRenewalMetaData {
          headers {
            banner
            heading
            subHeading
            description
          }
          subscriptionWidget {
            thumbnailImage
            title
            subTitle
            limitedTime
            discount
            subcriptionValidity
          }
        }
        lapserMetaData {
          headers {
            banner
            heading
            subHeading
            description
          }
          subscriptionWidget {
            thumbnailImage
            title
            subTitle
            limitedTime
            discount
            subcriptionValidity
          }
        }
        lapserInfo {
          action
          actionText
        }
        checkoutInfo {
          banner
          checkoutWidget {
            image
            subcriptionValidity
            tierKey
            limitedTime
            discount
          }
          paymentDetails {
            scan
            makePayment
            upiApp
            orVisitWebsite
            renew
          }
        }
        discount {
          amount
          currency
          discountType
          planDiscountedPrice
        }
      }
    }
  }
`;
